<template>
    <div>
        <div class="tw-flex">
            <div class="tw-w-1/4 tw-py-2">
                <span class="text-light">Phone Number</span>
            </div>
            <div v-if="phoneData.complete_details.phone.phone_number == ''" class="tw-text-md tw-pl-2 tw-flex tw-flex-col" style="word-break: break-word">
                <span class="flex tw-px-2 tw-py-1"> - </span>
            </div>
            <div v-else class="tw-w-3/4 tw-py-2 tw-flex tw-flex-col">
                <span class="tw-pl-3">{{ phoneData.complete_details.phone.phone_number }}</span>
                <!-- <span class="tw-pl-3 text-light ">{{phoneData.complete_details.phone.messages}}</span> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "email",

    props: {
        phoneData: {
            type: Object,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style>
.text-light {
    color: rgb(148 163 184);
}
</style>
